import React from "react";
import { Field } from "redux-form";

import { CustomSwitch } from "../../../../../../common/customSwitch";

import styles from "../../../../JobStyle.module.css";

export default function JobSwmsFormV3SectionPanelHeader({
  config,
  sectionKey,
  isDraggableSection,
  isDraggingSection,
  loading,
  onDragStart,
  onDragEnd,
  onDragEnter,
  onDragOver,
  onDrop
}) {
  return (
    <div
      className={`${styles.BackgroundSectionHeading} custom-section-v2-panel-heading`}
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        transition: "background-color 120ms ease",
        backgroundColor: isDraggingSection ? "#EFE7FF" : undefined,
        cursor: isDraggingSection ? "grabbing" : "pointer"
      }}
      draggable={isDraggableSection && !loading}
      onDragStart={onDragStart}
      onDragEnd={onDragEnd}
      onDragEnter={onDragEnter}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {config.bucket === "fixed" ? (
        <span aria-hidden="true" style={{ display: "inline-flex", color: "#362148" }}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="14" height="14">
            <path fill="currentColor" d="M256 160L256 224L384 224L384 160C384 124.7 355.3 96 320 96C284.7 96 256 124.7 256 160zM192 224L192 160C192 89.3 249.3 32 320 32C390.7 32 448 89.3 448 160L448 224C483.3 224 512 252.7 512 288L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 288C128 252.7 156.7 224 192 224z" />
          </svg>
        </span>
      ) : null}
      {isDraggableSection ? (
        <span
          aria-hidden="true"
          style={{ display: "inline-flex", color: "#362148", opacity: 0.8, cursor: loading ? "default" : (isDraggingSection ? "grabbing" : "grab") }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" width="14" height="14">
            <path fill="currentColor" d="M40 352l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zm192 0l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 320c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 192l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40zM40 160c-22.1 0-40-17.9-40-40L0 72C0 49.9 17.9 32 40 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0zM232 32l48 0c22.1 0 40 17.9 40 40l0 48c0 22.1-17.9 40-40 40l-48 0c-22.1 0-40-17.9-40-40l0-48c0-22.1 17.9-40 40-40z" />
          </svg>
        </span>
      ) : null}
      {config.heading}
      {(config.bucket === "swms_content_management" || config.bucket === "method_item_type") ? (
        <div
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          className="float-right position-relative"
          style={{ right: "30px", marginLeft: "auto" }}
        >
          <Field
            name={`sections.${sectionKey}.data.toggle`}
            size="small"
            className="cs-switch-v3"
            component={CustomSwitch}
            disabled={loading}
          />
        </div>
      ) : null}
    </div>
  );
}